/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { useNavigate, useParams, useLocation } from "react-router";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { useTour } from "@reactour/tour";

/* 🧩 COMPONENTS */
import { InputSelect, Input, InputPassword, Label, Button, Modal, CustomLoading, InputCheckbox, Breadcrumb, CustonModal, GeneralTab, SecurityTab, UnitsTab } from "../../../Components";

/* 🔗 SERVICE */
import { UserServices } from "../../../Services/userServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeLoations, changeLoationtypes, changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Ajuda } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, ContainerRow, ButtonsContainer, ButtonsModal, ModalText,
        QrcodeContainer, InputContainer, BackupCodeContainer, BackupCodesContainer, FromContainer, ContainerCheckbox, 
        ContainerVariaveisItem, TitleEquipament, NumberInput, ContainerInputs, Text, ColumnContainer, SearchContainer, ModalContent,
        RowContainer } from "./styles";
import { HelpIcon } from "../../styles";

/* 🔧 UTILS */
import { FormatPhone, FormatWpp, isValidField, isValidPassword, isValidPassword2 } from "../../../util/validate";
import { profileSteps } from "../../../util/tour/profile";

const UserProfile = () => {
    const location = useLocation();
    const { t } = useTranslation();
    
    document.title = t("administrative.sub-items.employees.view.document-title");

    const navigationFlow =  [
        ...(location.pathname !== '/perfil'
        ? [
            { text: 'administrative', page: '/adm/funcionarios' },
            { text: 'employees', page: '/adm/funcionarios' },
        ]
        : []),
        { text: 'profile', page: null },
    ]

    const user = useSelector(state => state.userReducer);
    const navigate = useNavigate();
    let { userId } = useParams();

    if(!userId){
        userId = user.user.id;
    }

    const { isOpen, setIsOpen, currentStep, setSteps } = useTour();
    const steps = profileSteps(t);

    const userRef = useRef('');
    const currentConfig = useRef([]);

    const alocacao_typeField = useRef();
    const alocacaoField = useRef();
    const CargoField = useRef();
    const NameField = useRef();
    const UserField = useRef();
    const PhoneField = useRef();
    const WhatsappField = useRef();
    const MailField = useRef();
    const passwordField = useRef();
    const newpasswordField = useRef();
    const confirmpasswordField = useRef();
    const CodedField = useRef();
    const RecoveryCodedField = useRef();
    const WhatsappCodedField = useRef();
    const PhoneCodedField = useRef();

    const passwordValue = useRef();
    const newpasswordValue = useRef();
    const confirmpasswordValue = useRef();
    const CodedValue = useRef();
    const RecoveryCodedValue = useRef();
    const WhatsappCodedValue = useRef();
    const PhoneCodedValue = useRef();

    const hasaccessparametricValue = useRef();
    const hasaccessallallocationsValue = useRef();
    
    const Services = useRef(new UserServices());

    const [loading, setLoading] = useState(true);
    const [totalVariaveis, setTotalVariaveis] = useState([]);
    const [subscribeConfig, setSubscribeConfig] = useState({});
    const [activeModal, setActiveModal] = useState("");
    
    const [qrcode, setQrcode] = useState();
    const [usuario, setUsuario] = useState();
    const [activeId, setActiveId] = useState(0);


    const [equipamentsAdd, setEquipamentsAdd] = useState([]);
    const [cities, setCities] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [city, setCity] = useState('');
    const [searchEquipament, setSearchEquipament] = useState('');
    const AllEquipaments = useRef([]);

    const [time, setTime] = useState({hour: '09', minute: '00', second: '00', interval: '10'});
    const [finalTime, setFinalTime] = useState({hour: '18', minute: '00', second: '00'});
    const [subscribeType, setSubscribeType] = useState({
        "sms": false,
        "email": false,
        "whatsapp": false
    });

    const tabs = [
        { id: 0, label: 'personal-data' },
        { id: 1, label: 'security-settings' },
        { id: 2, label: 'measurement-units' },
    ];

    const commonProps = { userId, Services, usuario, setUsuario };

    const reorderedTabs = [
        tabs.find(tab => tab.id === activeId),
        ...tabs.filter(tab => tab.id !== activeId),
    ];

    const renderTab = () => {
        switch (activeId) {
            case 0:
                return <GeneralTab {...commonProps} setActiveModal={setActiveModal} />;
            case 1:
                return <SecurityTab {...commonProps} />;
            case 2:
                return <UnitsTab {...commonProps} />;
            default:
            return null;
        }
    };

    // Busca o qrcode de autenticação
    const getqrcode = async() => {
        let code = await Services.current.getCode();
        setQrcode(code);
    }

    /* eslint-disable */
    // Desativa warning de dependencia de variavel
    useEffect(() => {
        // Busca dados do usuário
        const getUser = async() => {
            setLoading(true)
            let userdata = await Services.current.getUser(userId);
            userRef.current = userdata;
            setUsuario(userdata);
            try {
                hasaccessparametricValue.current = userdata.hasaccessparametric
                hasaccessallallocationsValue.current = userdata.hasaccessallallocations
                if(userdata.name){
                    NameField.current.value = userdata.name;
                    NameField.current.focus();
                }
                if(userdata.username){
                    UserField.current.value = userdata.username;
                    UserField.current.focus();
                }
                if(userdata.contacts?.phone){
                    const formatted = FormatPhone(userdata.contacts.phone);
                    PhoneField.current.value = formatted;
                    PhoneField.current.focus();
                }
                if(userdata.contacts?.whatsapp){
                    const formatted = FormatWpp(userdata.contacts.whatsapp);
                    WhatsappField.current.value = formatted;
                    WhatsappField.current.focus();
                }
                if(userdata.contacts?.email){
                    MailField.current.value = userdata.contacts.email;
                    MailField.current.focus();
                }
            } catch (error) {
                console.log(error)
            }

            let Locations = [
                {
                    id: userdata.allocation?.id,
                    name: userdata.allocation?.name,
                }
            ];
            let Types = [
                {
                    id: userdata.allocation?.type?.name,
                    name: userdata.allocation?.type?.name,
                }
            ];
            store.dispatch(changeLoations(Locations));
            store.dispatch(changeLoationtypes(Types));
            try {
                alocacao_typeField.current.value = userdata.allocation?.type.name;
                alocacaoField.current.value = userdata.allocation?.id;
                setTimeout(() => {
                    CargoField.current.value = userdata.role?.id
                    CargoField.current.focus();
                }, 500);
            } catch (error) {
                
            }
      
            if(userId === user.user.id && userdata?.security?.has2fa !== true){
                getqrcode();
            }
            getLocations(userdata);
            setLoading(false)
        }

        // Busca alocações do usuário
        const getLocations = async(userdata) => {
            try {
                let AllLocations = await Services.current.getLocations();
                let Types = Object.keys(AllLocations).map(type => {
                    return{
                        id: type,
                        name: type
                    }
                })
                store.dispatch(changeLoations(AllLocations[userdata.allocation?.type.name]))
                store.dispatch(changeLoationtypes(Types));
                alocacao_typeField.value = userdata.allocation?.type.name;
            } catch (error) {
                console.log(error)
            }
        }

        const getCargos = async() => {
            try {
                await Services.current.getAuthorizedCargos();
            } catch (error) {
    
            }
        }

        const getEquipamentsSubscribes = async() => {
            try {
                let equipaments = await Services.current.getEquipamentsSubscribes();
                setEquipamentsAdd(equipaments)
                AllEquipaments.current = equipaments
            } catch (error) {
                
            }
        }

        const getCities = async() => {
            try {
                let newCities = await Services.current.getCities();
                setCities(newCities)
            } catch (error) {
                console.log(error)                
            }
        }

        const getPermissions = async(userId) => {
            try {
                let Permissions = await Services.current.GetPermissions(userId);
                setPermissions(Permissions)
            } catch (error) {
                console.log(error)
                setPermissions([])                
            }
        }

        
        getUser();
        getCargos();
        getCities();
        getEquipamentsSubscribes();
        getPermissions(userId);

        if (userId === user.user.id) {
            setSteps(steps.slice(0, 1).concat(steps.slice(3)));
        } else {
            setSteps(steps.slice(0, 3));
        }

        return () => {
            setIsOpen(false);      
            setSteps([]);           
        };
    }, [userId]);
    /* eslint-enable */

    // Função para copiar os códigos de recuperação
    const CopyCodes = () => {
        let stringCopy = ''
        qrcode.backupCodes.map(code => {
            stringCopy += code + '\n'
            return code;
        })
        try {
            navigator.clipboard.writeText(stringCopy)
            toast(t("message.users.view.copy-codes"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        } catch (error) {
        }
    }

    // Filtra equipamentos
    const filterEquipaments = (equipamentName, city) => {
        try {
            let filter = AllEquipaments.current;
            if(equipamentName && city){
                filter = AllEquipaments.current.filter((equipament) => equipament.nome.toLowerCase().includes(equipamentName.toLowerCase()) && parseInt(equipament.city_code) === parseInt(city));
            }else if(equipamentName){
                filter = AllEquipaments.current.filter((equipament) => equipament.nome.toLowerCase().includes(equipamentName.toLowerCase())); 
            }else if(city){
                filter = AllEquipaments.current.filter((equipament) => parseInt(equipament.city_code) === parseInt(city));
            }
            setEquipamentsAdd(filter);
        } catch (error) {
            console.log(error)
        }
    }
    
    const validateHour = (value) => {
        const num = parseInt(value, 10);

        if (isNaN(num) || num < 0) return '00';
        if (num > 23) return '23';

        return num.toString().padStart(2, '0');   
    }

    const validateMinute = (value) => {
        const num = parseInt(value, 10);

        if (isNaN(num) || num < 0) return '00';
        if (num > 59) return '59';

        return num.toString().padStart(2, '0');  
    }

    // Função para iniciar o tour
    const handleTour = () => {
        if (activeId === 0) {
            setIsOpen(true);
        } else {
            toast(t("message.users.view.start-tour"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }
    
    return (
        <>
            <Container $isTourOpen={isOpen}>
                <div className="header">
                    <Breadcrumb flow={navigationFlow}/>
                    <Button onClick={() => handleTour()} icon={<HelpIcon src={Ajuda} className={"icon"} />} disabled={loading} padding={"8px 10px"} radius={"3px"} width={"44px"}/>
                </div>
                <div className="buttons-container">
                    {reorderedTabs.map((tab, i) => (
                        <Button key={i} text={t(`buttons.${tab.label}`)} id={tab.label} borderRadius={"8px"} onClick={() => setActiveId(tab.id)} disabled={(tab.id === 1 || tab.id === 2) && (userId !== user.user.id)}/>
                    ))}
                </div>
                {  loading ? <CustomLoading width={'150px'} height={'150px'}/> : renderTab() }

            </Container>

            <CustonModal Title={t("modal.delete-employee.title")} Active={activeModal === 'delete-employee'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} onClick={() => Services.current.deleteUser(userId, navigate)}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>

            {userId === user.user.id &&           
                <>
                    <Modal title={t("modal.two-factor_auth.title")} id={"two-factor-auth-modal"} name={'f2aModal'} width={'35%'} height={usuario?.security?.has2fa !== true ? '80%' : '50%'}>
                        {usuario?.security?.has2fa !== true ?
                            <ModalContent $isTourOpen={isOpen}>
                                <div id="codes">
                                    <ModalText>
                                        <Trans i18nKey="modal.two-factor_auth.text.first" components={{ br: <br /> }} />
                                    </ModalText>
                                    {qrcode?.backupCodes?
                                        <BackupCodesContainer onClick={() => CopyCodes()}>
                                            {qrcode?.backupCodes?.map((backup, index) => (
                                                <BackupCodeContainer key={index}>{backup} </BackupCodeContainer>
                                                ))}
                                        </BackupCodesContainer>
                                    :null}
                                </div>
                               <div id="qr-code">
                                    <ModalText>
                                        <Trans i18nKey="modal.two-factor_auth.text.second" components={{ br: <br /> }} />
                                    </ModalText>
                                    {qrcode?.qrCode ?
                                        <>
                                            <QrcodeContainer>
                                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(qrcode.qrCode)}} />
                                            </QrcodeContainer>
                                            <ModalText>
                                                {t("modal.two-factor_auth.text.third")}
                                            </ModalText>
                                        </>
                                    :<></>}
                                    
                                    <InputContainer id="code-submit">
                                        <Input 
                                            aling="flex-start"
                                            id="code" 
                                            name="code" 
                                            type="number" 
                                            placeholder={t("inputs.code.placeholder")}
                                            innerRef={CodedField}
                                            invalidMessage={t("inputs.code.invalid-message")}
                                            validationFunction={(text) => isValidField(text)}
                                            onchange={(text) => CodedValue.current = text}> 
                                        </Input>

                                        <Button text={t("buttons.submit")} width={'120px'} color={'green'} disabled={isOpen && currentStep === 3} onClick={() => {
                                            if(CodedValue.current !== null &&  CodedValue.current !== undefined && CodedValue.current !== ''){
                                                store.dispatch(changeModal(''));
                                                Services.current.sendCode(CodedValue.current, (state) => setUsuario(
                                                    {...usuario, security: {has2fa: state}}
                                                ));
                                            }
                                        }}/>
                                    </InputContainer>
                               </div>
                            </ModalContent>
                            :
                            <>
                                <ModalText>
                                    {t("modal.two-factor_auth.alternative-text")}
                                </ModalText>
                                <InputContainer>
                                    <Input 
                                        aling="flex-start"
                                        id="recoverycode" 
                                        name="recoverycode" 
                                        type="text" 
                                        placeholder={t("inputs.code.placeholder")}
                                        innerRef={RecoveryCodedField}
                                        invalidMessage={t("inputs.code.invalid-message")}
                                        validationFunction={(text) => isValidField(text)}
                                        onchange={(text) => RecoveryCodedValue.current = text}> 
                                    </Input>

                                    <Button text={t("buttons.submit")} width={'120px'} color={'green'} onClick={() => {
                                        if(RecoveryCodedValue.current !== null &&  RecoveryCodedValue.current !== undefined && RecoveryCodedValue.current !== ''){
                                            store.dispatch(changeModal(''));
                                            Services.current.sendVerifyCode(RecoveryCodedValue.current, 
                                            (state) => setUsuario({...usuario, security: {has2fa: state}}), 
                                            () => getqrcode());
                                        }
                                    }}/>
                                </InputContainer>
                            </>}
                    </Modal>
                
                    <Modal title={t("modal.confirm-whatsapp.title")} name={'whatsappModal'} width={'35%'} height={'35%'}>
                        <ModalText>
                            {t("modal.confirm-whatsapp.text")}
                        </ModalText>

                        <InputContainer>
                            <Input 
                                aling="flex-start"
                                id='whatsappcode' 
                                name='whatsappcode' 
                                type="text" 
                                placeholder={t("inputs.code.placeholder")}
                                innerRef={WhatsappCodedField}
                                invalidMessage={t("inputs.code.invalid-message")}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => WhatsappCodedValue.current = text}> 
                            </Input>

                            <Button text={t("buttons.submit")} width={'120px'} color={'green'} onClick={() => {
                                Services.current.sendWhatsappCodeConfirm(WhatsappCodedValue.current)
                            }}/>
                        </InputContainer>

                    </Modal>

                    <Modal title={t("modal.confirm-phone.title")} name={'phoneModal'} width={'35%'} height={'35%'}>
                        <ModalText>
                            {t("modal.confirm-phone.text")}
                        </ModalText>

                        <InputContainer>
                            <Input 
                                aling="flex-start"
                                id='phonecode' 
                                name='phonecode' 
                                type="text" 
                                placeholder={t("inputs.code.placeholder")}
                                innerRef={PhoneCodedField}
                                invalidMessage={t("inputs.code.invalid-message")}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => PhoneCodedValue.current = text}> 
                            </Input>

                            <Button text={t("buttons.submit")} width={'120px'} color={'green'} onClick={() => {
                                Services.current.sendPhoneCodeConfirm(PhoneCodedValue.current)
                            }}/>
                        </InputContainer>

                    </Modal>

                    <Modal title={t("modal.update-password.title")} name={'changePasswordModal'} width={'40%'} height={'65%'}>
                        <FromContainer onSubmit={(e) => e.preventDefault()}>
                            <Label text={t("inputs.current-password.label")} aling="flex-start"/>
                            <InputPassword 
                                id='oldpassword' 
                                name='oldpassword' 
                                innerRef={passwordField}
                                placeholder={t("inputs.current-password.placeholder")}
                                invalidMessage={t("inputs.current-password.invalid-message")}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => passwordValue.current = text}>
                            </InputPassword>

                            <Label text={t("inputs.new-password.label")} aling="flex-start"/>
                            <InputPassword 
                                id='password' 
                                name='password' 
                                placeholder={t("inputs.new-password.placeholder")}
                                innerRef={newpasswordField}
                                invalidMessage={t("inputs.new-password.invalid-message")}
                                validationFunction={(text) => isValidPassword(text)}
                                onchange={(text) => newpasswordValue.current = text}>
                            </InputPassword>


                            <Label text={t("inputs.confirm-password.label")} aling="flex-start"/>
                            <InputPassword 
                                id='newpasswordconfirm' 
                                name='newpasswordconfirm' 
                                placeholder={t("inputs.confirm-password.placeholder")}
                                innerRef={confirmpasswordField}
                                invalidMessage={t("inputs.confirm-password.invalid-message")}
                                validationFunction={(text) => isValidPassword2(text, newpasswordValue.current)}
                                onchange={(text) => confirmpasswordValue.current = text}>
                            </InputPassword>

                            <ButtonsModal>
                                <Button text={t("buttons.cancel")} width={'120px'} color={'white-red'} onClick={() => store.dispatch(changeModal(''))}/>
                                <Button text={t("buttons.save")} width={'120px'} onClick={() => {
                                    store.dispatch(changeModal(''));
                                    Services.current.ChangePassword(passwordValue.current, newpasswordValue.current, confirmpasswordValue.current,
                                    (isValidField(passwordValue.current) && isValidPassword(newpasswordValue.current) && isValidPassword(confirmpasswordValue.current) ));
                                }}/>
                            </ButtonsModal>
                        </FromContainer>
                    </Modal>

                    <Modal title={t("modal.user-subscribes.title")} name={'userSubscribes'} width={'60%'} height={'80%'}>

                        {subscribeConfig?.equipamentId ?
                            <>
                                <TitleContainer>
                                    <TitleEquipament>Escolha o horário e as variáveis para inscrição do equipamento {subscribeConfig.equipamentName}</TitleEquipament>
                                </TitleContainer>

                                <ContainerRow>
                                    <ColumnContainer>
                                        <Label text="Horário incial" aling="flex-start"/>
                                        <ContainerInputs>
                                            <NumberInput type='number' value={time.hour} onChange={(e) => setTime({...time, "hour": validateHour(e.target.value)})}></NumberInput>
                                            <Text>:</Text>
                                            <NumberInput type='number' value={time.minute} onChange={(e) => setTime({...time, "minute": validateMinute(e.target.value)})}></NumberInput>
                                            <Text>:</Text>
                                            <NumberInput type='number' value={time.second} onChange={(e) => setTime({...time, "second": validateMinute(e.target.value)})}></NumberInput>
                                        </ContainerInputs>
                                    </ColumnContainer>
                                    
                                    <ColumnContainer>
                                        <Label text="Horário final" aling="flex-start"/>
                                        <ContainerInputs>
                                            <NumberInput type='number' value={finalTime.hour} onChange={(e) => setFinalTime({...finalTime, "hour": validateHour(e.target.value)})}></NumberInput>
                                            <Text>:</Text>
                                            <NumberInput type='number' value={finalTime.minute} onChange={(e) => setFinalTime({...finalTime, "minute": validateMinute(e.target.value)})}></NumberInput>
                                            <Text>:</Text>
                                            <NumberInput type='number' value={finalTime.second} onChange={(e) => setFinalTime({...finalTime, "second": validateMinute(e.target.value)})}></NumberInput>
                                        </ContainerInputs>
                                    </ColumnContainer>
                                </ContainerRow>

                                <Label text="Intervalo entre notificações (minutos)" aling="flex-start"/>
                                <ContainerInputs>
                                    <NumberInput type='number' value={time.interval} onChange={(e) => {
                                        if(e.target.value >= 0 && parseFloat(e.target.value)){
                                            setTime({...time, "interval": e.target.value})
                                        }else{
                                            setTime({...time, "interval": 10})
                                        }
                                    }}></NumberInput>
                                </ContainerInputs>
                                
                                <ContainerCheckbox onSubmit={(e) => e.preventDefault()}>
                                    {
                                        totalVariaveis.map((item, index) => (
                                            <ContainerVariaveisItem key={index} >
                                                <InputCheckbox id={item.id} name={item.id} text={item.name} checked={item.checked} 
                                                    onChange={async(value) => {
                                                        if(value){
                                                            currentConfig.current.push(item.id);
                                                        }else{
                                                            currentConfig.current = currentConfig.current.filter(id => id !== item.id);
                                                        }
                                                        item.checked = value;
                                                        return true;
                                                    }}/>
                                            </ContainerVariaveisItem>
                                        ))
                                    }
                                </ContainerCheckbox>
                                
                                <TitleContainer>
                                    <TitleEquipament>Selecione por onde você deseja receber as notificações</TitleEquipament>
                                </TitleContainer>

                                <ContainerInputs>
                                    {/* <InputCheckbox id={'SubscribeSMS'} name={'SubscribeSMS'} text={'SMS'} checked={subscribeType.sms} 
                                        onChange={(value)=>{
                                            setSubscribeType({...subscribeType, sms: value})
                                        }}/> */}
                                    
                                    <InputCheckbox id={'SubscribeEmail'} name={'SubscribeEmail'} text={'Email'} checked={subscribeType.email}
                                        onChange={(value) => {
                                            setSubscribeType({...subscribeType, email: value});
                                        }
                                    }/>

                                    <InputCheckbox id={'SubscribeWhatsapp'} name={'SubscribeWhatsapp'} text={'Whatsapp'} checked={subscribeType.whatsapp}
                                        onChange={(value) => {
                                            setSubscribeType({...subscribeType, whatsapp: value});
                                        }
                                    }/>
                    
                                </ContainerInputs>

                                <ButtonsContainer>
                                    <Button text={t("buttons.save")} width={'120px'} onClick={async() => {
                                        try {
                                            let subscribe = await Services.current.subscribe(subscribeConfig.equipamentId, currentConfig.current, time, finalTime, subscribeType)
                                            if(subscribe){
                                                setTotalVariaveis([]);
                                                setSubscribeConfig({});
                                                currentConfig.current = [];
                                            }
                                        } catch (error) {
                                            console.log(error)
                                            toast(error.message, {
                                                position: "top-center",
                                                type: 'error',
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: false,
                                                draggable: false,
                                                progress: undefined,
                                            });
                                        }
                                    }}/>
                                    <Button text={t("buttons.cancel")} width={'120px'} color={'white-red'} onClick={() => {
                                        currentConfig.current = []
                                        let equipaments = equipamentsAdd
                                        equipaments[subscribeConfig.index].checked = false
                                        equipaments[subscribeConfig.index].is_subscribed = false
                                        setEquipamentsAdd(equipaments)
                                        setSubscribeConfig({})
                                        setTotalVariaveis([])
                                    }}/>
                                </ButtonsContainer>
                            </>
                        :
                            <>
                                <SearchContainer>
                                    <Label text={t("inputs.city.label")} aling="flex-start"/>
                                    <InputSelect
                                        key={'Filtercity'}
                                        name={'Filtercity'}
                                        id={'Filtercity'}
                                        placeholder={t("select.city")}
                                        value={city}
                                        options={cities}
                                        validationFunction={(value) => {return true}}
                                        onchange={(value) => {
                                            setCity(value);
                                            if(value){
                                                filterEquipaments(searchEquipament ,value);
                                            }else{
                                                setEquipamentsAdd(AllEquipaments.current);
                                            }
                                        }}>
                                    </InputSelect>

                                    <Label text={t("inputs.equipment-name.label")} aling="flex-start"/>
                                    <Input
                                        aling="flex-start"
                                        id='equipamentName'
                                        name='equipamentName'
                                        type="text"
                                        placeholder={t("inputs.equipment-name.placeholder")}
                                        validationFunction={(text) => {return true}}
                                        value={searchEquipament}
                                        onchange={(text) => {
                                            setSearchEquipament(text);
                                            filterEquipaments(text, city);
                                        }}>
                                    </Input>
                                </SearchContainer>
                                
                                <ContainerCheckbox onSubmit={(e) => e.preventDefault()}>
                                    {
                                        equipamentsAdd?.map((item, index) => (
                                            <ContainerVariaveisItem key={index} >
                                                <InputCheckbox id={item.id} name={item.id} text={item.nome} checked={item.checked || item.is_subscribed} 
                                                    onChange={async(value) => {
                                                        if(value){
                                                            let variaveis = await Services.current.GetVariables(item.id);
                                                            setTotalVariaveis(variaveis);
                                                            setSubscribeConfig({
                                                                equipamentId: item.id,
                                                                equipamentName: item.nome,
                                                                index: index,
                                                            })
                                                        }else{
                                                            await Services.current.unsubscribe(userId, item.id) ;                                                       
                                                        }
                                                        item.checked = value;
                                                        item.is_subscribed = value;
                                                        return true;
                                                    }}/>
                                            </ContainerVariaveisItem>
                                        ))
                                    }
                                </ContainerCheckbox>
                            </>
                        }
                    </Modal>
                </>
            }

            <Modal title={t("modal.user-permissions.title")} name={'userPermissions'} width={'60%'} height={'80%'}>
                <>
                    <SearchContainer>
                        <Label text={t("inputs.city.label")} aling="flex-start"/>
                        <InputSelect
                            key={'Filtercity'}
                            name={'Filtercity'}
                            id={'Filtercity'}
                            placeholder={t("select.city")}
                            value={city}
                            options={cities}
                            validationFunction={(value) => {return true}}
                            onchange={(value) => {
                                setCity(value);
                                if(value){
                                    filterEquipaments(searchEquipament ,value);
                                }else{
                                    setEquipamentsAdd(AllEquipaments.current);
                                }
                            }}>
                        </InputSelect>

                        <Label text={t("inputs.equipment-name.label")} aling="flex-start"/>
                        <Input
                            aling="flex-start"
                            id='equipamentName-permissions'
                            name='equipamentName-permissions'
                            type="text"
                            placeholder={t("inputs.equipment-name.placeholder")}
                            validationFunction={(text) => {return true}}
                            value={searchEquipament}
                            onchange={(text) => {
                                setSearchEquipament(text);
                                filterEquipaments(text, city);
                            }}>
                        </Input>
                    </SearchContainer>
                    
                    
                    <ContainerCheckbox onSubmit={(e) => e.preventDefault()}>
                        {
                            equipamentsAdd?.map((item, index) => (
                                <ContainerVariaveisItem key={index} >
                                    <InputCheckbox id={item.id} name={item.id} text={item.nome} checked={item.checked || (permissions.length > 1 && permissions?.includes(item.id))} //item.can_send_commands
                                        onChange={async(value) => {
                                            if(value){
                                                await Services.current.permission(userId, item.id);
                                                // item.checked = value;
                                                // return true;
                                            }else{
                                                await Services.current.unpermission(userId, item.id);
                                                // item.checked = value;
                                                // return true;
                                            }
                                            item.checked = value;
                                            return true;
                                        }}
                                        />
                                </ContainerVariaveisItem>
                            ))
                        }
                    </ContainerCheckbox>
                </>
            </Modal>
        </>
    );
}

export default UserProfile;